import { API_URL } from "./config";
import { useEffect, useState } from "react";
import db from "./Firebase";
import {
  collection,
  getDocs,
  query,
  doc,
  setDoc,
  getDoc,
} from "firebase/firestore";
import "./TodoEdit.css"

import Button from "react-bootstrap/Button";
import { AiFillDelete, AiFillCheckCircle, AiFillSave, AiOutlineSortAscending, AiOutlinePlusCircle, AiFillForward } from "react-icons/ai"

import _ from "lodash";
import moment from "moment";

import { Container, Row, Col } from "react-bootstrap";
import token from "./Token";
import { mqttUpdate } from "./mqttUtils";

import Spinner from "react-bootstrap/Spinner";

function TodoEdit() {
  const [todos, setTodos] = useState([]);
  const [savingStamp, setSavingStamp] = useState(false);

  useEffect(() => {
    // Change document title
    document.title = "Edit Todos";

    // If locked redirect to home
    if (localStorage.getItem('locked') == 'true') {
      window.location.href = '/'
    }
    
    loadTodosFromNewServer();
  }, [])

  const getRandomString = (len) => {
    let randomString = "";
    let randomAscii;
    for (let i = 0; i < len; i++) {
      randomAscii = Math.floor(Math.random() * 25 + 97);
      randomString += String.fromCharCode(randomAscii);
    }
    return randomString;
  }

  const loadTodosFromNewServer = async () => {
    try {
      const response = await fetch(API_URL + "/allTodos?token=" + token);
      const data = await response.json();
      if (data.hasOwnProperty("todo")) {
        let todos = _.cloneDeep(data.todo)
        todos.forEach((todo) => {
          todo.id = getRandomString(48)
          if (todo.deferUntil === undefined) {
            todo.deferStr = ""
          } else {
            todo.deferStr = moment(todo.deferUntil).format("DD/MM/YYYY HH:mm:ss")
            todo.deferUntil = moment(todo.deferUntil).toDate()
          }
        })
        setTodos(todos)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const loadTodos = async () => {
    console.log("loadTodos");
    const documentSnapshot = await getDoc(doc(db, "todo", "default"))
    let enumeratedTodos = _.cloneDeep(documentSnapshot.data().todo)
    enumeratedTodos.forEach((todo) => {
      todo.id = getRandomString(48)
      if (todo.deferUntil === undefined) {
        todo.deferStr = ""
      } else {
        todo.deferStr = moment(todo.deferUntil.toDate()).format("DD/MM/YYYY HH:mm:ss")
        todo.deferUntil = todo.deferUntil.toDate()
      }
    })
    setTodos(enumeratedTodos)
  }

  const handleTextChange = (todo, e, fieldName) => {
    let mTodo = _.cloneDeep(todos)
    if (fieldName === 'title') {
      // Find the matching todo in mTodo 
      mTodo.forEach((item) => {
        if (item.id === todo.id) {
          item.content = e.target.value
        }
      })
    } else if (fieldName === 'defer') {
      // Find the matching todo in mTodo 
      mTodo.forEach((item) => {
        if (item.id === todo.id) {
          let deferValue = e.target.value
          // if deferValue contains the string 'd', it means that the user has entered the number of days
          if (deferValue.indexOf('d') > -1) {
            try {
              // remove the 'd' character
              let daysString = deferValue.replace('d', '')
              // convert to number
              let days = Number(daysString)
              // convert to Date
              let deferDate = moment().add(days, 'days').set('hour', 2).set('minute', 0).set('second', 0).set('millisecond', 0)
              item.deferStr = deferDate.format("DD/MM/YYYY HH:mm:ss")
              item.deferUntil = deferDate.toDate()
            } catch (error) {
              item.deferStr = deferValue
            }
          } else {
            item.deferStr = deferValue
            try {
              item.deferUntil = moment(deferValue, "DD/MM/YYYY HH:mm:ss").toDate()
            } catch (err) {
              // do nothing 
            }
          }
        }
      })
    } else if (fieldName === 'notes') {
      // Find the matching todo in mTodo 
      mTodo.forEach((item) => {
        if (item.id === todo.id) {
          item.notes = e.target.value
        }
      })
    }
    setTodos(mTodo)
  }

  const deleteTodo = (todo) => {
    let mTodo = _.cloneDeep(todos)
    // remove the todo from mTodo
    mTodo = mTodo.filter((item) => item.id !== todo.id)
    setTodos(mTodo)
  }

  const addTodo = () => {
    let mTodo = _.cloneDeep(todos)
    mTodo.unshift({
      id: getRandomString(48),
      content: "",
      deferStr: "",
      notes: ""
    })
    setTodos(mTodo)
  }

  const sortTodos = () => {
    let mTodo = _.cloneDeep(todos)
    // Sort the todos by deferUntil
    mTodo.sort((a, b) => {
      if (a.deferUntil === undefined) {
        return 1
      } else if (b.deferUntil === undefined) {
        return -1
      } else {
        return a.deferUntil - b.deferUntil
      }
    })
    setTodos(mTodo)
  }

  const saveTodo = async () => {
    let mTodos = _.cloneDeep(todos)
    // remove id, deferStr and add deferUntil if not exist
    mTodos.forEach((todo) => {
      if (todo.deferStr !== undefined) {
        delete todo.deferStr
      }
      delete todo.id
      if (todo.deferUntil === undefined) {
        todo.deferUntil = moment().toDate()
      }
    })
    let saveObj = { todo: mTodos }

    // Save to firebase
    await setDoc(doc(db, "todo", "default"), saveObj)
    // Update MQTT
    try {
      await mqttUpdate("todos")
      // alert("Saved successfully")
    } catch (err) {
      console.error('MQTT update failed:', err)
      // alert("Saved successfully (but MQTT notification failed)")
    }
  }

  const saveTodoToNewServer = async () => {
    setSavingStamp(true)
    let mTodos = _.cloneDeep(todos)
    // remove id, deferStr and add deferUntil if not exist
    mTodos.forEach((todo) => {
      if (todo.deferStr !== undefined) {
        delete todo.deferStr
      }
      delete todo.id
      if (todo.deferUntil === undefined) {
        todo.deferUntil = moment().toDate()
      }
    })
    let saveObj = { todo: mTodos, practicalId: 'default' }

    // Save to firebase
    const payload = "data=" + JSON.stringify(saveObj)

    let response = await fetch(API_URL + "/setAllTodos?token=" + token, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      },
      body: payload
    })
    let data = await response.json()
    console.log(data)
    // Update MQTT
    try {
      await mqttUpdate("todos")
      // alert("Saved successfully")
    } catch (err) {
      console.error('MQTT update failed:', err)
      // alert("Saved successfully (but MQTT notification failed)")
    }
    setSavingStamp(false)
  }

  const getTheNext2am = () => {
    let now = moment()
    let next2am = moment().startOf('day').add(2, 'hour')
    if (now.isAfter(next2am)) {
      next2am = next2am.add(1, 'day')
    }
    // return next2am.add(1, 'day') // for tomorrow print
    return next2am // for today print
  }

  function getNext(dayOfWeek) {
    let today = moment();
    if (dayOfWeek === 'MON') {
      let daysUntilMonday = 1 - today.day();
      if (daysUntilMonday <= 0) daysUntilMonday += 7;
      return today.add(daysUntilMonday, 'days').hour(2).minute(0).second(0)
    } else if (dayOfWeek === 'TUE') {
      let daysUntilTuesday = 2 - today.day();
      if (daysUntilTuesday <= 0) daysUntilTuesday += 7;
      return today.add(daysUntilTuesday, 'days').hour(2).minute(0).second(0)
    } else if (dayOfWeek === 'WED') {
      let daysUntilWednesday = 3 - today.day();
      if (daysUntilWednesday <= 0) daysUntilWednesday += 7;
      return today.add(daysUntilWednesday, 'days').hour(2).minute(0).second(0)
    } else if (dayOfWeek === 'THU') {
      let daysUntilThursday = 4 - today.day();
      if (daysUntilThursday <= 0) daysUntilThursday += 7;
      return today.add(daysUntilThursday, 'days').hour(2).minute(0).second(0)
    } else if (dayOfWeek === 'FRI') {
      let daysUntilFriday = 5 - today.day();
      if (daysUntilFriday <= 0) daysUntilFriday += 7;
      return today.add(daysUntilFriday, 'days').hour(2).minute(0).second(0)
    } else if (dayOfWeek === 'SAT') {
      let daysUntilSaturday = 6 - today.day();
      if (daysUntilSaturday <= 0) daysUntilSaturday += 7;
      return today.add(daysUntilSaturday, 'days').hour(2).minute(0).second(0)
    } else if (dayOfWeek === 'SUN') {
      let daysUntilSunday = 7 - today.day();
      if (daysUntilSunday <= 0) daysUntilSunday += 7;
      return today.add(daysUntilSunday, 'days').hour(2).minute(0).second(0)
    }
  }

  const advanceTodos = () => {
    let mTodos = _.cloneDeep(todos)
    let todosTouche = []
    mTodos.forEach((todo) => {
      if (todo.hasOwnProperty("deferUntil")) {
        let next2am = getTheNext2am()
        if (moment(todo.deferUntil).isBefore(next2am)) {
          todo.deferUntil = next2am.toDate()
          todo.deferStr = moment(todo.deferUntil).format("DD/MM/YYYY HH:mm:ss")
          todosTouche.push(todo.content)
        }
      }
    })
    setTodos(mTodos)
    alert("Advanced todos: " + todosTouche.join(", "))
    // sortTodos()
  }

  const modifyTodoDeferShortcut = (todo, param) => {
    let next2am = getTheNext2am()
    let mTodos = _.cloneDeep(todos)
    mTodos.forEach((item) => {
      if (item.id === todo.id) {
        if (param == 'NX') {
          item.deferUntil = moment().toDate()
          item.deferStr = moment(item.deferUntil).format("DD/MM/YYYY HH:mm:ss")
        }
        if (param == '1') {
          item.deferUntil = next2am.toDate()
          item.deferStr = moment(item.deferUntil).format("DD/MM/YYYY HH:mm:ss")
        } else if (param == '+1') {
          item.deferUntil = moment(item.deferUntil).add(1, 'day').hour(2).minute(0).second(0).toDate()
          item.deferStr = moment(item.deferUntil).format("DD/MM/YYYY HH:mm:ss")
        } else if (param == '-1') {
          item.deferUntil = moment(item.deferUntil).subtract(1, 'day').hour(2).minute(0).second(0).toDate()
          item.deferStr = moment(item.deferUntil).format("DD/MM/YYYY HH:mm:ss")
        } else if (param == 'MO') {
          item.deferUntil = getNext('MON').toDate()
          item.deferStr = moment(item.deferUntil).format("DD/MM/YYYY HH:mm:ss")
        } else if (param == 'TU') {
          item.deferUntil = getNext('TUE').toDate()
          item.deferStr = moment(item.deferUntil).format("DD/MM/YYYY HH:mm:ss")
        } else if (param == 'WE') {
          item.deferUntil = getNext('WED').toDate()
          item.deferStr = moment(item.deferUntil).format("DD/MM/YYYY HH:mm:ss")
        } else if (param == 'TH') {
          item.deferUntil = getNext('THU').toDate()
          item.deferStr = moment(item.deferUntil).format("DD/MM/YYYY HH:mm:ss")
        } else if (param == 'FR') {
          item.deferUntil = getNext('FRI').toDate()
          item.deferStr = moment(item.deferUntil).format("DD/MM/YYYY HH:mm:ss")
        } else if (param == 'SA') {
          let nextSaturday = getNext('SAT').toDate()
          item.deferUntil = nextSaturday
          item.deferStr = moment(item.deferUntil).format("DD/MM/YYYY HH:mm:ss")
        } else if (param == 'SU') {
          let nextSunday = getNext('SUN').toDate() // next Sunday
          item.deferUntil = nextSunday
          item.deferStr = moment(item.deferUntil).format("DD/MM/YYYY HH:mm:ss")
        }
      }
    })
    setTodos(mTodos)
  }

  return (
    <div className='AppRootDesktop'><div className='AppRootInnerOverlay'>
      <Row className="align-items-center action-bar g-0">
          <Col xs={12} md={6}>
            <h1>Edit Todos</h1>
          </Col>
          <Col xs={12} md={6} className="text-md-end">
            <div className="action-buttons-grid">
              <Button variant="primary" onClick={() => addTodo()}><AiOutlinePlusCircle /> ADD</Button>
              <Button variant="primary" onClick={() => sortTodos()}><AiOutlineSortAscending /> SORT</Button>
              <Button variant="primary" onClick={() => { advanceTodos() }}><AiFillForward /> ADVANCE</Button>
              {!savingStamp && <Button variant="success" onClick={() => saveTodoToNewServer()}><AiFillSave /> SAVE</Button>}
            </div>
          </Col>
        </Row>
      <Container className="todo-edit-page">
        

        {savingStamp && <div className='loading-spinner-container'>
          <Spinner animation='border' role='status' />
          <span className="ms-2">Saving...</span>
        </div>}

        <div className="todo-cards-container">
          {todos.map((todo) => {
            const shortcuts1 = ['NX', '+1', '-1', 'MO', 'TU'];
            const shortcuts2 = ['WE', 'TH', 'FR', 'SA', 'SU'];
            return (
              <div key={todo.id} className="todo-card">
                <div className="form-group todo-title">
                  <input className="form-control" type="text" value={todo.content} placeholder="Todo content..." onChange={(e) => handleTextChange(todo, e, 'title')} />
                </div>
                <div className="form-group">
                  <input className="form-control" type="text" value={todo.deferStr} placeholder="Defer until (DD/MM/YYYY HH:mm:ss)" onChange={(e) => handleTextChange(todo, e, 'defer')} />
                </div>
                <div className="form-group">
                  <input className="form-control" type="text" value={todo.notes || ""} placeholder="Notes..." onChange={(e) => handleTextChange(todo, e, 'notes')} />
                </div>

                {todo.deferUntil && <div className={`due-date-display ${moment(todo.deferUntil).isBefore(moment()) ? 'warn' : ''}`}>
                  Due {moment(todo.deferUntil).fromNow()}, {moment(todo.deferUntil).format("dddd")}
                </div>}

                <div className="shortcut-buttons">
                  {shortcuts1.map(sc => (
                    <Button key={sc} variant="dark" size="sm" onClick={() => { modifyTodoDeferShortcut(todo, sc) }}>{sc}</Button>
                  ))}
                </div>
                 <div className="shortcut-buttons">
                  {shortcuts2.map(sc => (
                    <Button key={sc} variant="dark" size="sm" onClick={() => { modifyTodoDeferShortcut(todo, sc) }}>{sc}</Button>
                  ))}
                </div>

                <div className="delete-button-container">
                  <Button variant="danger" onClick={() => deleteTodo(todo)}><AiFillDelete /> DELETE</Button>
                </div>
              </div>
            )
          })}
        </div>
      </Container>
    </div></div>
  )
}

export default TodoEdit
